var __TEMP__ = require('./_copyObject.js');var copyObject = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./keys.js');var keys = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = baseAssign;
